import React, { FC } from "react";

type TabPanelProps = {
  children: React.ReactNode;
  value: number;
  index: number;
  id: string;
  ariaLabelledBy: string;
  className?: string;
};

const TabPanel: FC<TabPanelProps> = ({ children, value, index, id, ariaLabelledBy, className }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`${id}-${index}`}
      aria-labelledby={`${ariaLabelledBy}-${index}`}
      className={className}
    >
      {value === index && children}
    </div>
  );
};

export default TabPanel;
